import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/photo-collage-maker"
    exact
    path="/consumer/features/photo-collage-maker"
    component={AsyncPage}
  />,
];
